import { useQuery } from '@tanstack/vue-query'
import { userInfoApi } from '../userInfoApi'

export function useUserInfoQuery() {
    return useQuery({
        queryKey: ['userInfo'],
        queryFn: async () => {
            const userInfo = await userInfoApi.get()
            return userInfo
        },
    })
}
